import { render, staticRenderFns } from "./ExamesComplementares.vue?vue&type=template&id=6f9da31a"
import script from "./ExamesComplementares.vue?vue&type=script&lang=js"
export * from "./ExamesComplementares.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports